// extracted by mini-css-extract-plugin
module.exports = {"label":"KeyFormLabel__label___kU-0a","input":"KeyFormLabel__input___2APjA","textEllipsis":"KeyFormLabel__textEllipsis___1k40P"};